import { requestLocation, requestTextMessageLocation, startSession, caseTransferRequest, checkForActiveSession, checkCaseTransfer, requestMultipleLocationsByTextMessage, startOverwatchSession, startOverwatchWeaSession, requestNewNumberLocations, helpRequestRequestMessage, getActiveTeamSearches} from '@/services/location-request'
import socket, { createObserverSocket } from '@/services/socket'
import { RootState } from '@/store'
import { ActionContext, Module } from 'vuex'
import { saveAs } from 'file-saver'
import JSZip from 'jszip'
import { SOCKETIO_EVENTS } from '../../../server/src/stream/stream.constants'
import axios from 'axios'
import store from '@/store'
import i18n from '@/i18n'
import authentication, { AuthenticationState, authenticationTypes } from './authentication'
// import { createImportSpecifier, validateLocaleAndSetLanguage } from 'typescript'

// Twilio mediaUrl for archive upload; never send base64 data URLs.
function resolveArchiveMediaUrl(mediaItem: { mediaUrl?: string; url?: string } | null | undefined): string | undefined {
    const candidates = [mediaItem?.mediaUrl, mediaItem?.url]
    for (const candidate of candidates) {
        if (typeof candidate === 'string' && candidate.length > 0 && !candidate.startsWith('data:')) {
            return candidate
        }
    }
    return undefined
}

export interface Location {
    altitude: string
    address: string
    uncertaintyRadiusInMeters: number
    ipAddress: string
    id: number
    latitude: string
    longitude: string
    capturedFromSource: string
    dateTimeCaptured: string
    dateTimeStored: string
    timestamp: number
    socketId: string
    speed: number
}
export interface Log {
    // Log Message
    message: string
    // Logged time
    time: number
    // Maybe use to store icons
    icon?: string
}

export interface TeamActiveCase {
    uuid: string
    phoneNumber: string
    fullName: string
    latitude: string | null
    longitude: string | null
    address?: string
    uncertaintyRadiusInMeters?: number
    speed?: number
    altitude?: string
    dateTimeStored?: string
    isSharingLocation?: boolean
}

export interface LocationState {
    path: string
    connectionRequest: any
    locations: Location[]
    s3Data: any[]
    chatMessages?: any[]
    status: string
    showSmsConfirmation: boolean
    phoneNumber: string
    log: Log[]
    callListNumbers: any
    newNumbersList: any
    observationLinkNumbers: any
    observationLinkEmails: any
    callerConnected: boolean
    isTabFocused: boolean
    isSharingLocation: boolean
    isSharingLocationByNumber: any
    isObserver: boolean
    sharedNumbersList: any[]
    sharedTargetsList: any[]
    evidenceSubmittedNumbers: string[]
    evidenceSubmissionsByNumber: Record<string, {
        formData: Record<string, unknown> | null
        locationCoords: { latitude: number; longitude: number; accuracy: number } | null
        mediaFileNames: Array<string | { fileName: string; contentType?: string; url?: string }>
    }[]>
    alertPortalInformationByKey: Record<string, {
        name?: string
        phoneNumber?: string
        emergencyDescription?: string
        portalId?: string
    }[]>
    isResponse: boolean
    locationType: string | null
    showWaitingForLocationModal: boolean
    showEmailVerificationModal: boolean
    showClearedDomainModal: boolean
    showEditEmailModal: boolean
    locationRequestError: string | null
    showCallTransferModal: boolean
    showAcceptCallTransferModal: boolean
    showAcceptCallObservationrModal: boolean
    caseRequestUuid: string
    originalStreamUuid: string
    requestStreamUuid: string
    caseTransferStatus: boolean
    caseObservationStatus: boolean
    caseTransferWatcher: boolean
    caseObservationWatcher: boolean
    showCaseTransferModal: boolean
    showFindByNumbersModal: boolean
    showFindByListModal: boolean
    showCreateCallListModal: boolean
    showAddUsersToCLModal: boolean
    showServiceAlertModal: boolean
    showAddNumbersModal: boolean
    showShareCaseBySmsModal: boolean
    showUserProfileModal: boolean
    checkCaseTransfer: boolean
    checkCaseObservation: boolean
    thisSocketToken: string
    caseRequestSocketToken: string
    locationInterval: ReturnType<typeof setInterval> | null
    dateTimeCompleted: boolean
    language: string
    deepLLanguage: string
    deliveryMethod: string
    overwatchMessageType: string
    customSmsText: string
    showA2PMessagingModal: boolean
    showA2PMobileMessagingModal: boolean
    showA2POverwatchModal: boolean
    chatInitiated: boolean
    showAPIUserMetricModal: boolean
    weatherCondition: any
    observerSocket: any | null;
    overwatchGeoWatchId: any
        weaIdentifier: string
        weaLink: string
    teamActiveCases: TeamActiveCase[]
    teamCaseSockets: Record<string, any>
}

const LocationModule: Module<LocationState, RootState> = {
    namespaced: true,
    state: {
        connectionRequest: null,
        path: '',
        s3Data: [],
        chatMessages: [],
        locations: [],
        status: 'Not Connected',
        showSmsConfirmation: false,
        phoneNumber: '',
        log: [],
        callListNumbers: [],
        newNumbersList: [],
        observationLinkNumbers: [],
        observationLinkEmails: [],
        callerConnected: false,
        isTabFocused: false,
        isSharingLocation: false,
        isSharingLocationByNumber: {},
        isObserver: false,
        sharedNumbersList: [],
        sharedTargetsList: [],
        evidenceSubmittedNumbers: [],
        evidenceSubmissionsByNumber: {},
        alertPortalInformationByKey: {},
        isResponse: false,
        locationType: null,
        showWaitingForLocationModal: false,
        showEmailVerificationModal: false,
        showClearedDomainModal: false,
        showEditEmailModal: false,
        locationRequestError: null,
        showCallTransferModal: false,
        showFindByNumbersModal: false,
        showFindByListModal: false, 
        showCreateCallListModal: false,
        showAddUsersToCLModal: false,
        showAcceptCallTransferModal: false,
        showAcceptCallObservationrModal: false,
        showServiceAlertModal: true,
        showAddNumbersModal: false,
        showShareCaseBySmsModal: false,
        showUserProfileModal: false,
        caseTransferStatus: false,
        caseObservationStatus: false,
        caseTransferWatcher: false,
        caseObservationWatcher: false,
        caseRequestUuid: '',
        originalStreamUuid: '',
        requestStreamUuid: '',
        showCaseTransferModal: false,
        checkCaseTransfer: false,
        checkCaseObservation: false,
        thisSocketToken: '',
        caseRequestSocketToken: '',
        dateTimeCompleted: false,
        locationInterval: null,
        language: 'English',
        deepLLanguage: 'Off',
        deliveryMethod: 'standard',
        overwatchMessageType: 'link',
        customSmsText: '',
        showA2PMessagingModal: false,
        showA2PMobileMessagingModal: false,
        showA2POverwatchModal: false,
        chatInitiated: false,
        showAPIUserMetricModal: false,
        weatherCondition: null,
        observerSocket: null,
        overwatchGeoWatchId: null,
        weaIdentifier: '',
        weaLink: '',
        teamActiveCases: [],
        teamCaseSockets: {},
    },
    mutations: {
        connectionRequest(state, connectionRequest) {
            state.connectionRequest = connectionRequest
        },
        reset(state) {
            state.path = ''
            state.locations = []
            state.status = 'Not Connected'
            state.showSmsConfirmation = false
            state.phoneNumber = ''
            state.log = []
            state.callListNumbers = []
            state.newNumbersList = []
            state.observationLinkNumbers = []
            state.observationLinkEmails = []
            state.callerConnected = false
            state.isTabFocused = false
            state.isSharingLocation = false
            state.isSharingLocationByNumber = {}
            state.isObserver = false
            state.sharedNumbersList = []
            state.sharedTargetsList = []
            state.evidenceSubmittedNumbers = []
            state.evidenceSubmissionsByNumber = {}
            state.alertPortalInformationByKey = {}
            state.isResponse = false
            state.locationType = null
            state.showWaitingForLocationModal = false
            state.showEmailVerificationModal = false
            state.showClearedDomainModal = false
            state.showEditEmailModal = false
            state.locationRequestError = null
            state.showCallTransferModal = false
            state.showFindByNumbersModal = false
            state.showFindByListModal = false
            state.showCreateCallListModal = false
            state.showAddUsersToCLModal = false
            state.showAcceptCallTransferModal = false
            state.showAcceptCallObservationrModal = false
            state.showServiceAlertModal = true
            state.showAddNumbersModal = false
            state.showShareCaseBySmsModal = false
            state.showUserProfileModal =false
            state.caseTransferStatus = false
            state.caseObservationStatus = false
            state.caseTransferWatcher = false
            state.caseObservationWatcher = false
            state.caseRequestUuid = ''
            state.originalStreamUuid = ''
            state.requestStreamUuid = ''
            state.showCaseTransferModal = false
            state.checkCaseTransfer = false
            state.checkCaseObservation = false
            state.thisSocketToken = ''
            state.caseRequestSocketToken = ''
            state.dateTimeCompleted = false
            state.language = 'English'
            state.deepLLanguage = 'Off'
            state.deliveryMethod = 'standard'
            state.overwatchMessageType = 'link'
            state.customSmsText = ''
            clearInterval(state.locationInterval)
            state.showA2PMessagingModal = false
            state.showA2PMobileMessagingModal = false
            state.showA2POverwatchModal =false
            state.chatInitiated = false
            state.showAPIUserMetricModal = false
            state.weatherCondition = null
            state.observerSocket = null
            state.overwatchGeoWatchId = null
            Object.values(state.teamCaseSockets).forEach((s: any) => s.disconnect())
            state.teamCaseSockets = {}
            state.teamActiveCases = []
        },
        teamActiveCases(state, cases: TeamActiveCase[]) {
            state.teamActiveCases = cases
        },
        updateTeamCaseLocation(state, { uuid, location }: { uuid: string; location: Location }) {
            const activeCase = state.teamActiveCases.find(x => x.uuid === uuid)
            if (activeCase) {
                activeCase.isSharingLocation = true
                activeCase.latitude = location.latitude
                activeCase.longitude = location.longitude
                activeCase.address = location.address
                activeCase.uncertaintyRadiusInMeters = location.uncertaintyRadiusInMeters
                activeCase.speed = location.speed
                activeCase.altitude = location.altitude
                activeCase.dateTimeStored = location.dateTimeStored
            }
        },
        updateTeamCaseSharing(state, { uuid, isSharingLocation }: { uuid: string; isSharingLocation: boolean }) {
            const activeCase = state.teamActiveCases.find(x => x.uuid === uuid)
            if (!activeCase) return

            activeCase.isSharingLocation = isSharingLocation
            if (!isSharingLocation) {
                activeCase.latitude = null
                activeCase.longitude = null
                activeCase.address = undefined
                activeCase.uncertaintyRadiusInMeters = undefined
                activeCase.speed = undefined
                activeCase.altitude = undefined
                activeCase.dateTimeStored = undefined
            }
        },
        setTeamCaseSocket(state, { uuid, socket }: { uuid: string; socket: any }) {
            state.teamCaseSockets = { ...state.teamCaseSockets, [uuid]: socket }
        },
        resetTeamLive(state) {
            Object.values(state.teamCaseSockets).forEach((s: any) => s.disconnect())
            state.teamCaseSockets = {}
            state.teamActiveCases = []
        },
        addLocation(state, location: Location) {
            state.locations.push(location)
            state.s3Data.push(location)
        },
        addS3Data(state, location: Location) {
            state.s3Data.push(location)
        },
        showSmsConfirmation(state, show: boolean) {
            state.showSmsConfirmation = show
        },
        phoneNumber(state, phoneNumber: string) {
            state.phoneNumber = phoneNumber
        },
        overwatchGeoWatchId(state, value) {
            state.overwatchGeoWatchId = value
        },
        weaIdentifier(state, value) {
            state.weaIdentifier = value
        },
        weaLink(state, value) {
            state.weaLink = value
        },
        path(state, path) {
            state.path = path
        },
        status(state, newStatus: string) {
            state.status = newStatus
        },
        log(state, entry: string) {
            state.log.push({
                message: entry,
                time: Date.now()
            })
        },
        callList(state, callList: any) {
            state.callListNumbers = callList
        },
        newNumbers(state, newNumbers: any) {
            state.newNumbersList = newNumbers
        },
        observationLinkNumbers(state, numbers: any) {
            state.observationLinkNumbers = numbers
        },
        observationLinkEmails(state, emails: any) {
            state.observationLinkEmails = emails
        },
        callerConnected(state, isConnected: boolean) {
            state.callerConnected = isConnected
        },
        isTabFocused(state, value: boolean) {
            state.isTabFocused = value
        },
        isSharingLocation(state, value: boolean) {
            state.isSharingLocation = value
        },
        isSharingLocationByNumber(state, value: any) {
            state.isSharingLocationByNumber = value
        },
        isObserver(state, value: boolean) {
            state.isObserver = value
        },
        sharedNumbersList(state, sharedNumbersList: any) {
            state.sharedNumbersList = sharedNumbersList
        },
        sharedTargetsList(state, sharedTargetsList: any) {
            state.sharedTargetsList = sharedTargetsList
        },
        addEvidenceSubmittedNumber(state, phoneNumber: string) {
            if (phoneNumber && !state.evidenceSubmittedNumbers.includes(phoneNumber)) {
                state.evidenceSubmittedNumbers.push(phoneNumber)
            }
        },
        addEvidenceSubmission(state, payload: {
            portalId?: string
            phoneNumber?: string
            formData?: Record<string, unknown> | null
            locationCoords?: { latitude: number; longitude: number; accuracy: number } | null
            mediaFileNames?: Array<string | { fileName: string; contentType?: string; url?: string }>
        }) {
            const keys = [...new Set([payload.portalId, payload.phoneNumber].filter(Boolean))] as string[]
            if (!keys.length) return
            const entry = {
                formData: payload.formData ?? null,
                locationCoords: payload.locationCoords ?? null,
                mediaFileNames: Array.isArray(payload.mediaFileNames) ? payload.mediaFileNames : [],
            }
            keys.forEach((key) => {
                if (!state.evidenceSubmittedNumbers.includes(key)) {
                    state.evidenceSubmittedNumbers.push(key)
                }
                if (!state.evidenceSubmissionsByNumber[key]) {
                    state.evidenceSubmissionsByNumber[key] = []
                }
                state.evidenceSubmissionsByNumber[key].push(entry)
            })
        },
        addAlertPortalInformation(state, payload: {
            name?: string
            phoneNumber?: string
            emergencyDescription?: string
            portalId?: string
        }) {
            const key = payload.portalId || payload.phoneNumber
            if (!key) return
            if (!state.alertPortalInformationByKey[key]) {
                state.alertPortalInformationByKey[key] = []
            }
            state.alertPortalInformationByKey[key].push({
                name: payload.name,
                phoneNumber: payload.phoneNumber,
                emergencyDescription: payload.emergencyDescription,
                portalId: payload.portalId,
            })
        },
        isResponse(state, value: boolean) {
            state.isResponse = value
        },
        locationType(state, value: string) {
            state.locationType = value
        },
        showWaitingForLocationModal(state, value: boolean) {
            state.showWaitingForLocationModal = value
        },
        showEmailVerificationModal(state, value: boolean) {
            state.showEmailVerificationModal = value
        },
        showClearedDomainModal(state, value: boolean) {
            state.showClearedDomainModal = value
        },
        showEditEmailModal(state, value: boolean) {
            state.showEditEmailModal = value
        },
        locationRequestError(state, value: string | null) {
            state.locationRequestError = value
        },
        showCallTransferModal(state, value:boolean | null){
            state.showCallTransferModal = value
        },
        showAcceptCallTransferModal(state, value:boolean | null){
            state.showAcceptCallTransferModal = value
        },
        showAcceptCallObservationrModal(state, value:boolean | null) {
            state.showAcceptCallObservationrModal = value
        },
        showFindByNumbersModal(state, value:boolean | null){
            state.showFindByNumbersModal = value
        },
        showFindByListModal(state, value:boolean | null){
            state.showFindByListModal = value
        },
        showCreateCallListModal(state, value:boolean | null){
            state.showFindByListModal = value
        },
        showServiceAlertModal(state, value:boolean | null){
            state.showServiceAlertModal = value
        },
        showAddNumbersModal(state) {
            state.showAddNumbersModal = !state.showAddNumbersModal
        },
        showShareCaseBySmsModal(state, value: boolean) {
            state.showShareCaseBySmsModal = value
        },
        showAddUsersToCLModal(state, value:boolean | null){
            state.showAddUsersToCLModal = value
        },
        showCaseTransferModal(state, value:boolean | null){
            state.showCaseTransferModal = value
        },
        showUserProfileModal(state, show: boolean) {
            state.showUserProfileModal = show
        },
        changeCaseRequestUuid(state, value: string | null){
            state.caseRequestUuid = value
        },
        caseRequestSocketToken(state, value: string) {
            state.caseRequestSocketToken = value
        },
        addPhoneNumber(state, value: string | null){
            state.phoneNumber = value
            console.log(value)
        },
        setLanguage(state, value:string){
            state.language = value
        },
        setDeepLLanguage(state, value:string){
            if(value == 'English'){
                state.deepLLanguage = 'Off' //default to no translation required
            }
            else if (value == 'Spanish'){
                state.deepLLanguage = 'es'
            }
            else if (value == 'Portuguese'){
                state.deepLLanguage = 'pt-BR'
            }
            else if (value == 'French'){
                state.deepLLanguage = 'fr'
            }
            else if (value == 'German'){
                state.deepLLanguage = 'de'
            }
            else if (value == 'Italian'){
                state.deepLLanguage = 'it'
            }
            else if (value == 'Mandarin'){
                state.deepLLanguage = 'zh'
            }
            else if (value == 'Arabic'){
                state.deepLLanguage = 'ar'
            }
            else if (value == 'Japanese'){
                state.deepLLanguage = 'ja'
            }
        },
        setDeliveryMethod(state, value: string) {
            state.deliveryMethod = value
        },
        setOverwatchMessageType(state, value: string) {
            state.overwatchMessageType = value
        },
        setCustomSmsText(state, value: string) {
            state.customSmsText = value
        },
        showA2PMessagingModal(state, value: boolean){
            state.showA2PMessagingModal = value
        },
        showA2PMobileMessagingModal(state, value: boolean){
            state.showA2PMobileMessagingModal = value
        },
        showA2POverwatchModal(state, value: boolean){
            state.showA2POverwatchModal = value
        },
        chatInitiated(state, value:boolean | null){
            state.chatInitiated = value
        },
        showAPIUserMetricModal(state, value:boolean){
            state.showAPIUserMetricModal = value
        },
        saveWeatherCondition(state, value:any){
            state.weatherCondition = value
        },
        setChatMessages(state, messages: any[]) {
            state.chatMessages = messages
        },
        observerSocket(state, socketInstance) {
            state.observerSocket = socketInstance
        },
        observerCleanup(state) {
            state.locations = []
            state.s3Data = []
            state.log = []
            state.status = 'Not Connected'
            state.showSmsConfirmation = false
            state.showWaitingForLocationModal = false
            state.isSharingLocation = false
            state.isTabFocused = false
            state.isObserver = false
            state.sharedNumbersList = []
            state.sharedTargetsList = []
            state.evidenceSubmittedNumbers = []
            state.evidenceSubmissionsByNumber = {}
            state.alertPortalInformationByKey = {}
            state.showA2PMessagingModal = false
            state.showA2PMobileMessagingModal = false
            state.showA2POverwatchModal = false
            state.chatInitiated = false
            state.observerSocket = null
        },
    },
    actions: {
        //depreciated -> should always fall to sms request
        //session is made within this function no matter what
        async requestLocation({ dispatch, commit, state, rootState }): Promise<any> {
            //if the first char is a +, convert phone value to international
            let phone = state.phoneNumber
            if (state.phoneNumber[0] == "+"){
                phone = `${state.phoneNumber}`
            }
            else{
                phone = `+1${state.phoneNumber}`
            }
            commit('log', i18n.t('dashboard.log.requestedLocationFor', { phone }))

            try {
                const response = await startSession({ phoneNumber: phone })

                if (response.data.token) {
                    commit('connectionRequest', response.data)
                    await dispatch('startConnection', response.data.token)
                }
            } catch (e) {
                // @ts-ignore
                if (e.response && e.response.data.error) {
                    // @ts-ignore
                    const message = e.response.data.error
                    if (message === 'verify-email') return commit('showEmailVerificationModal', true)
                    if (message === 'unauthorized-domain') return commit('showClearedDomainModal', true)
                }
            }
            // Call to SMS confirmation modal
            commit('showSmsConfirmation', true)
            commit('log', i18n.t('dashboard.log.unableToAutoRetrieveLocation'))
            commit('status', 'Unable to automatically retrieve location')
        },
        async requestMultipleLocations({ dispatch, commit, state }) {
            // Will need to create a version of this for multiple numbers
            const response = await startOverwatchSession({ phoneNumbers: state.callListNumbers })

            if (response.data.token) {
                commit('connectionRequest', response.data)
                await dispatch('startConnection', response.data.token)
            }

            // Initiate request SMS send
            requestMultipleLocationsByTextMessage({
                connectionRequestUuid: state.connectionRequest.uuid,
                callList: state.callListNumbers,
                language: state.language,
                messageType: state.overwatchMessageType,
                customSms: state.customSmsText,
                deliveryMethod: state.deliveryMethod,
            })
        },
        requestNewNumberLocations({ dispatch, state, commit }) {
            // Update callListNumbers in the state with newNumbersList
            const updatedCallListNumbers = [...state.callListNumbers, ...state.newNumbersList]
            commit('callList', updatedCallListNumbers)
        
            requestNewNumberLocations({
                connectionRequestUuid: state.connectionRequest.uuid,
                newNumbers: state.newNumbersList,
                language: state.language,
                messageType: state.overwatchMessageType,
                customSms: state.customSmsText,
                deliveryMethod: state.deliveryMethod,
            })
        },
        async helpRequestRequestMessage({ state }, number) {
            helpRequestRequestMessage({
                connectionRequestUuid: state.connectionRequest.uuid,
                phoneNumber: number,
                language: state.language
            })
        },
        async requestLocationSms({ dispatch, commit, state }): Promise<any> {
            //if the first char is a +, convert phone value to international
            let phone = state.phoneNumber
            if (state.phoneNumber[0] == "+"){
                    phone = `${state.phoneNumber}`
            }
            else{
                phone = `+1${state.phoneNumber}`
            }
            commit('log', i18n.t('dashboard.log.requestedSmsLocationFor', { phone }))
            try {
                const response = await requestTextMessageLocation({
                    connectionRequestUuid: state.connectionRequest.uuid,
                    language: state.language,
                    deliveryMethod: state.deliveryMethod
                })
                if (response.data.token) {
                    commit('log', i18n.t('dashboard.log.requestForSmsLocationSent'))
                    commit('locationType', 'Text')
                    commit('showWaitingForLocationModal', true)
                    return
                }

                commit('log', i18n.t('dashboard.log.unableToRequestSmsLocation'))
                commit('status', 'Unable to send SMS request for location')
            } catch (e) {
                commit('log', i18n.t('dashboard.log.unableToRequestSmsLocation'))
                commit('status', 'Unable to send SMS request for location')
                // @ts-ignore
                if (e.response && e.response.data.error) {
                    // @ts-ignore
                    const message = e.response.data.error
                    if (message === 'verify-email') return commit('showEmailVerificationModal', true)
                    if (message === 'unauthorized-domain') return commit('showClearedDomainModal', true)
                }
            }
        },
        // Initialize the socket connection
        startConnection({ dispatch, commit, state }, token: string) {
            state.caseTransferWatcher = true
            state.caseObservationWatcher = true
            state.thisSocketToken = token
            commit('log', i18n.t('dashboard.log.connectingToServer'))
            socket.connect({ token })
            // axios.post(`api/v1/location/save-connect-socket/${state.connectionRequest.uuid}`)
            //     .then((response) => {
            //     })

            socket.on(SOCKETIO_EVENTS.NEW_LOCATION_AVAILABLE, (location: Location) => {
                // Don't add location if it's in the store
                const isLocationInStore = state.locations.find(
                    (existingLocation) => existingLocation.dateTimeCaptured === location.dateTimeCaptured
                )
               
                // Hide if reconnecting and locations come in.
                commit('showWaitingForLocationModal', false)
                commit('showSmsConfirmation', false)

                if (isLocationInStore) return

                if (location.capturedFromSource === 'TEXT_MESSAGE') commit('locationType', 'Text')

                // For dispatcher reconnection while caller is already connected.
                //TODO: Upon reconnecting, all statuses will resolve as true, where not necessarily true..
                if (!state.callerConnected) {
                    commit('log', i18n.t('dashboard.log.callerConnected'))
                    commit('callerConnected', true)
                }
                commit('showWaitingForLocationModal', false)
                commit('log', i18n.t('dashboard.log.newLocationReceived'))
                commit('isSharingLocation', true) //Not triggered under some conditions
                commit('isTabFocused', true) //Not triggered under some conditions*/
                commit('addLocation', location)
            })

            socket.on('connect', (location: Location) => {
                commit('log', i18n.t('dashboard.log.connectedToServer'))
                commit('status', 'Connected')
            })

            socket.on(SOCKETIO_EVENTS.CALLER_CONNECTED, (isConnected: Boolean) => {
                if (isConnected) {
                    commit('log', i18n.t('dashboard.log.callerConnected'))
                    commit('callerConnected', isConnected)
                } else {
                    commit('log', i18n.t('dashboard.log.callerDisconnected'))
                    commit('callerConnected', false)
                    commit('isTabFocused', false)
                    commit('isSharingLocation', false)
                    commit('isSharingLocationByNumber', [false, state.phoneNumber])
                }
            })

            socket.on(SOCKETIO_EVENTS.IS_TAB_FOCUSED, (value: Boolean) => {
                commit('isTabFocused', value)
            })

            socket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION, (value: Boolean) => {
                commit('isSharingLocation', value)
                if(value === false) {
                    commit('log', i18n.t('dashboard.log.callerStoppedSharing'))
                }
            })

            socket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, (value: any) => {
                // value = [phoneNumber, true/false]
                const updateMap = new Map(state.sharedNumbersList.map(status => [status[0], status[1]]));
                updateMap.set(value[0], value[1]);
                commit('sharedNumbersList', Array.from(updateMap.entries()));
            })

            socket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_TARGETID, (value: any) => {
                // value = [targetId, true/false]
                const updateMap = new Map(state.sharedTargetsList.map(status => [status[0], status[1]]));
                updateMap.set(value[0], value[1]);
                commit('sharedTargetsList', Array.from(updateMap.entries()));
            })

            socket.on(SOCKETIO_EVENTS.EVIDENCE_SUBMITTED_BY_NUMBER, (data: string | {
                portalId?: string
                phoneNumber?: string
                formData?: Record<string, unknown> | null
                locationCoords?: { latitude: number; longitude: number; accuracy: number } | null
                mediaFileNames?: Array<string | { fileName: string; contentType?: string; url?: string }>
            }) => {
                if (typeof data === 'string') {
                    commit('addEvidenceSubmission', { phoneNumber: data })
                    return
                }
                if (data?.portalId || data?.phoneNumber) {
                    commit('addEvidenceSubmission', data)
                }
            })

            socket.on(SOCKETIO_EVENTS.ALERT_PORTAL_INFORMATION_SUBMITTED, (data: {
                name?: string
                phoneNumber?: string
                emergencyDescription?: string
                portalId?: string
            }) => {
                if (data?.portalId || data?.phoneNumber) {
                    commit('addAlertPortalInformation', data)
                }
            })

            socket.on(SOCKETIO_EVENTS.LOCATION_SHARING_ERROR, (data: any) => {
                commit('log', i18n.t('dashboard.log.callerUnableToShareLocation', { data }))
            })

            socket.on('connect_timeout', (location: Location) => commit('status', 'connect_timeout'))
            socket.on('disconnect', (location: Location) => commit('status', 'Disconnected'))
            socket.on('reconnect_attempt', (location: Location) => commit('status', 'Attempting to Reconnect'))
            socket.on('reconnect', (location: Location) => commit('status', 'reconnect'))
            socket.on('error', (location: Location) => commit('status', 'error'))
            socket.on('reconnect_error', (location: Location) => commit('status', 'Attempting to Reconnect'))
            socket.on('reconnect_failed', (location: Location) => commit('status', 'Unable to Reconnect'))
        },
        setDateTimeCompleted({state}) {
            const uuid = state.caseRequestUuid || state.connectionRequest?.uuid
            if(uuid){
                axios.post(`api/v1/location/set-date-time-completed/${uuid}`)
            }
        },
        closeConnection({ commit, state }, payload) {
            /*axios.get(`api/v1/location/get-date-time-completed/${state.connectionRequest.uuid}`)
            .then((response) => {
                state.dateTimeCompleted = response.data
            })
            if (state.caseTransferStatus == false){
                //close normally
                socket.close()
                commit('log', i18n.t('dashboard.log.connectionClosed'))
            }
            else if (state.caseTransferStatus == true && state.dateTimeCompleted == false){
                //close if it was apart of a CT (first dispatcher)
                axios.post(`api/v1/location/participant-disconnect`)
                socket.disconnect() //socket is still open
            }
            else{
                //close if it was apart of CT (last dispatcher)
                socket.close()
            }*/
            socket.close()
            commit('log', i18n.t('dashboard.log.connectionClosed'))
        },
        reset({ dispatch, commit, state }) {
            if (state.observerSocket) {
                state.observerSocket.disconnectPermanently('observation ended')
            }
            dispatch('setDateTimeCompleted')
            dispatch('closeConnection')
            commit('showWaitingForLocationModal', false)
            commit('reset')
        },
        observationReset({ commit, state }) {
            if (state.observerSocket) {
                state.observerSocket.disconnectPermanently('observation ended')
                state.observerSocket = null
            }
            commit('observerCleanup')
        },
        async subscribeToTeamLive({ dispatch, commit, rootState }) {
            const teamId = rootState.authentication.teams[0]?.id
            if (!teamId) return

            const { data } = await getActiveTeamSearches(String(teamId))
            commit('teamActiveCases', data.map((uniqueCase: TeamActiveCase) => ({
                ...uniqueCase,
                latitude: null,
                longitude: null,
                isSharingLocation: false,
            })))
            for (const uniqueCase of data) {
                await dispatch('connectTeamCaseSocket', uniqueCase.uuid)
            }
        },
        async connectTeamCaseSocket({ commit, state }, uuid: string) {
            if (state.teamCaseSockets[uuid]) return

            const { data: token } = await axios.get(`/api/v1/location/get-connect-token/${uuid}`)
            const caseSocket = createObserverSocket(token)
            caseSocket.on(SOCKETIO_EVENTS.NEW_LOCATION_AVAILABLE, (location: Location) => {
                commit('updateTeamCaseLocation', { uuid, location })
            })
            caseSocket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION, (value: Boolean) => {
                commit('updateTeamCaseSharing', { uuid, isSharingLocation: !!value })
            })
            commit('setTeamCaseSocket', { uuid, socket: caseSocket })
        },
        disconnectTeamLive({ commit }) {
            commit('resetTeamLive')
        },
        downloadLocations({ state }) {
            const content = new Blob([JSON.stringify(state.locations)], { type: 'text/plain;charset=utf-8' })
            const fileName = `${state.phoneNumber}_${state.locations[0].dateTimeCaptured}.json`
            saveAs(content, fileName)
        },
        async downloadChatConvo({ state }, messages) {
            const json = Object.values(messages)
            let CSV = ''
            const keys = (json[0] && Object.keys(json[0])) || []

            const reversedKeys = Object.keys(json[0])
            const reversedValues = keys.map((key) => json.map((line) => line[key]))

            CSV += reversedKeys.join(',') + '\n'

            for (let i = 0; i < json.length; i++) {
                CSV += reversedValues.map((values) => values[i]).join(',') + '\n'
            }

            const content = new Blob([CSV], { type: 'text/plain;charset=utf-8' })
            const fileName = `SMS Chat-${new Date().toLocaleDateString()}-${state.phoneNumber}.csv`
            saveAs(content, fileName)
        },
        async uploadToS3({ state }) {
            const locations = state.s3Data.map((location) => ({
                Dispatcher: store.state.authentication.currentUser.firstName + ' ' + store.state.authentication.currentUser.lastName,
                PhoneNumber: state.phoneNumber,
                Longitude: location.longitude,
                Latitude: location.latitude,
                UncertaintyRadiusInMeters: location.uncertaintyRadiusInMeters.toFixed(2),
                Altitude: location.altitude.toFixed(4),
                Address: location.address,
                CapturedFromSource: location.capturedFromSource,
                CapturedAt: new Date(location.dateTimeCaptured).toUTCString()
            }))

            const chats = (state.chatMessages || []).map((message: any) => {
                const messageTime = message.author === 'Dispatcher'
                    ? { SentAt: message.SentAt }
                    : { ReceivedAt: message.ReceivedAt }

                const mediaItems = Array.isArray(message.media)
                    ? message.media.map((mediaItem: any, index: number) => {
                        const baseId =
                            mediaItem.uuid ||
                            mediaItem.id ||
                            `${message.id || 'msg'}-${index}`
                        const timestampPart =
                            mediaItem.timestamp ||
                            message.SentAt ||
                            message.ReceivedAt ||
                            new Date().toISOString()
                        const mediaId = `${baseId}-${timestampPart}`
                        const mimeType = mediaItem.contentType || mediaItem.mimeType || mediaItem.type || ''
                        const inferredExt =
                            (typeof mimeType === 'string' && mimeType.includes('/'))
                                ? mimeType.split('/')[1]
                                : ''
                        const extension = mediaItem.extension || inferredExt || 'bin'
                        const fileName = `media/${mediaId}.${extension}`
                        const archiveUrl = resolveArchiveMediaUrl(mediaItem)

                        return {
                            MediaId: mediaId,
                            Type: mediaItem.mediaType || mediaItem.kind || 'Media',
                            FileName: fileName,
                            Url: archiveUrl,
                            ContentType: mimeType
                        }
                    })
                    : []

                return {
                    PhoneNumber: state.phoneNumber,
                    Dispatcher: store.state.authentication.currentUser.firstName + ' ' + store.state.authentication.currentUser.lastName,
                    Author: message.author,
                    Text: message.text,
                    ...messageTime,
                    Media: mediaItems
                }
            })

            const flattenedMedia = chats.flatMap((chat: any) => chat.Media || [])

            const teamId = store.state.authentication.teams[0].id
            await axios.post(`/api/v1/aws/upload-to-s3/${teamId}/${state.connectionRequest.uuid}`, {
                locations,
                chats,
                mediaItems: flattenedMedia
                    .filter((m: any) => m.Url)
                    .map((m: any) => ({
                        url: m.Url,
                        contentType: m.ContentType,
                        fileName: m.FileName
                    }))
            })
        },
        async uploadOverwatchToS3({ state }) {
            const locations = state.s3Data.map((location) => {
                const sourceData = location.sourceData && typeof location.sourceData === 'object' ? location.sourceData : {}
                const phoneNumber = location.phoneNumber || sourceData.phoneNumber
                const targetId = location.targetId || sourceData.targetId
                return {
                    Dispatcher: store.state.authentication.currentUser.firstName + ' ' + store.state.authentication.currentUser.lastName,
                    PhoneNumber: phoneNumber,
                    targetId,
                    Longitude: location.longitude,
                    Latitude: location.latitude,
                    UncertaintyRadiusInMeters: location.uncertaintyRadiusInMeters.toFixed(2),
                    Altitude: location.altitude.toFixed(4),
                    Address: location.address,
                    CapturedFromSource: location.capturedFromSource,
                    CapturedAt: new Date(location.dateTimeCaptured).toUTCString()
                }
            })

            const chats = (state.chatMessages || []).map((message: any) => {
                const messageTime = message.author === 'Dispatcher'
                    ? { SentAt: message.SentAt }
                    : { ReceivedAt: message.ReceivedAt }

                const mediaItems = Array.isArray(message.media)
                    ? message.media.map((mediaItem: any, index: number) => {
                        const baseId =
                            mediaItem.uuid ||
                            mediaItem.id ||
                            `${message.id || 'msg'}-${index}`
                        const timestampPart =
                            mediaItem.timestamp ||
                            message.SentAt ||
                            message.ReceivedAt ||
                            new Date().toISOString()
                        const mediaId = `${baseId}-${timestampPart}`
                        const mimeType = mediaItem.contentType || mediaItem.mimeType || mediaItem.type || ''
                        const inferredExt =
                            (typeof mimeType === 'string' && mimeType.includes('/'))
                                ? mimeType.split('/')[1]
                                : ''
                        const extension = mediaItem.extension || inferredExt || 'bin'
                        const fileName = `media/${mediaId}.${extension}`
                        const archiveUrl = resolveArchiveMediaUrl(mediaItem)

                        return {
                            MediaId: mediaId,
                            Type: mediaItem.mediaType || mediaItem.kind || 'Media',
                            FileName: fileName,
                            Url: archiveUrl,
                            ContentType: mimeType
                        }
                    })
                    : []

                return {
                    PhoneNumber: message.phoneNumber,
                    Dispatcher: store.state.authentication.currentUser.firstName + ' ' + store.state.authentication.currentUser.lastName,
                    Author: message.author,
                    Text: message.text,
                    ...messageTime,
                    Media: mediaItems
                }
            })

            const flattenedMedia = chats.flatMap((chat: any) => chat.Media || [])

            const teamId = store.state.authentication.teams[0].id
            await axios.post(`/api/v1/aws/upload-overwatch-to-s3/${teamId}/${state.connectionRequest.uuid}`, {
                locations,
                chats,
                mediaItems: flattenedMedia
                    .filter((m: any) => m.Url)
                    .map((m: any) => ({
                        url: m.Url,
                        contentType: m.ContentType,
                        fileName: m.FileName
                    }))
            })
        },
        async acceptCaseTransfer({dispatch, commit, state}) {
            commit('log', i18n.t('dashboard.log.acceptedCallTransferRequest'))
            axios.post(`api/v1/location/mark-case-transfer-confirmation/${state.connectionRequest.uuid}/+1${state.phoneNumber}/${state.thisSocketToken}`)
            commit('reset')
        },
        async denyCaseTransfer({dispatch, commit, state}){
            commit('log', i18n.t('dashboard.log.deniedCallTransferRequest'))
            axios.post(`api/v1/location/mark-transfer/${state.connectionRequest.uuid}/+1${state.phoneNumber}/${0}`)
            .then((response) => {});
            state.caseTransferStatus = false
        },
        async checkTransfer({dispatch, commit, state}) {
            let phone = state.phoneNumber
            if (state.phoneNumber[0] == "+") phone = `${state.phoneNumber}`
            else phone = `+1${state.phoneNumber}`

            if (state.caseTransferWatcher)  {
                axios.get(`api/v1/location/check-transfer/${state.connectionRequest.uuid}/${phone}`)
                .then((response) => {
                    let caseTransfer = response.data
                    if (caseTransfer == true) {
                        state.caseTransferStatus = true
                        if (!state.showAcceptCallTransferModal) {
                            commit('showAcceptCallTransferrModal', true)
                        }
                    } else {
                        state.caseTransferStatus = false
                    }
                })
            }
        },
        async acceptCaseObservation({dispatch, commit, state}) {
            commit('log', i18n.t('dashboard.log.acceptedCallObservationRequest'))
            axios.post(`api/v1/location/mark-case-observation-confirmation/${state.connectionRequest.uuid}/+1${state.phoneNumber}/${state.thisSocketToken}`)
        },
        async denyCaseObservation({dispatch, commit, state}){
            commit('log', i18n.t('dashboard.log.deniedCallObservationRequest'))
            axios.post(`api/v1/location/mark-observation/${state.connectionRequest.uuid}/+1${state.phoneNumber}/${0}`)
            .then((response) => {});
            state.caseObservationStatus = false
        },
        async checkCaseTransferConfirmation({dispatch, commit, state}){
            let phone = state.phoneNumber
            if (state.phoneNumber[0] == "+") phone = `${state.phoneNumber}`
            else phone = `+1${state.phoneNumber}`

            axios.get(`api/v1/location/check-case-transfer/${state.caseRequestUuid}/${phone}`)
            .then((response) => {
                if (response.data)  {
                    state.caseRequestSocketToken = response.data
                    state.checkCaseTransfer = true
                }
                else {
                    state.caseRequestSocketToken = ''
                    state.checkCaseTransfer = false
                }
            })
        },
        async checkObservation({dispatch, commit, state}) {
            let phone = state.phoneNumber
            if (state.phoneNumber[0] == "+") phone = `${state.phoneNumber}`
            else phone = `+1${state.phoneNumber}`

            if (state.caseObservationWatcher)  {
                axios.get(`api/v1/location/check-observation/${state.connectionRequest.uuid}/${phone}`)
                .then((response) => {
                    let caseObservation = response.data
                    if (caseObservation == true) {
                        state.caseObservationStatus = true
                        if (!state.showAcceptCallObservationrModal) {
                            commit('showAcceptCallObservationrModal', true)
                        }
                    } else {
                        state.caseObservationStatus = false
                    }
                })
            }
        },
        async checkCaseObservationConfirmation({dispatch, commit, state}){
            let phone = state.phoneNumber
            if (state.phoneNumber[0] == "+") phone = `${state.phoneNumber}`
            else phone = `+1${state.phoneNumber}`

            axios.get(`api/v1/location/check-case-observation/${state.caseRequestUuid}/${phone}`)
            .then((response) => {
                if (response.data)  {
                    state.caseRequestSocketToken = response.data
                    state.checkCaseObservation = true
                }
                else {
                    state.caseRequestSocketToken = ''
                    state.checkCaseObservation = false
                }
            })
        },
        connectObserverWithToken({ commit, state }, socketToken: string) {
            const activeSocket = createObserverSocket(socketToken)
            commit('observerSocket', activeSocket)
            commit('log', i18n.t('dashboard.log.observerConnecting'))

            activeSocket.on(SOCKETIO_EVENTS.NEW_LOCATION_AVAILABLE, (location: Location) => {
                const isLocationInStore = state.locations.find(
                    (existingLocation) => existingLocation.dateTimeCaptured === location.dateTimeCaptured
                )
                if (isLocationInStore) return
                if (location.capturedFromSource === 'TEXT_MESSAGE') commit('locationType', 'Text')
                if (!state.callerConnected) {
                    commit('log', i18n.t('dashboard.log.callerConnected'))
                    commit('callerConnected', true)
                }
                commit('showWaitingForLocationModal', false)
                commit('showSmsConfirmation', false)
                commit('log', i18n.t('dashboard.log.newLocationReceived'))
                commit('isSharingLocation', true)
                commit('isTabFocused', true)
                commit('addLocation', location)
            })
            activeSocket.on('connect', () => {
                commit('log', i18n.t('dashboard.log.connectedToServer'))
                commit('status', 'Connected')
            })
            activeSocket.on(SOCKETIO_EVENTS.CALLER_CONNECTED, (isConnected: Boolean) => {
                if (isConnected) {
                    commit('log', i18n.t('dashboard.log.callerConnected'))
                    commit('callerConnected', isConnected)
                } else {
                    commit('log', i18n.t('dashboard.log.callerDisconnected'))
                    commit('callerConnected', false)
                    commit('isTabFocused', false)
                    commit('isSharingLocation', false)
                    commit('isSharingLocationByNumber', [false, state.phoneNumber])
                }
            })
            activeSocket.on(SOCKETIO_EVENTS.IS_TAB_FOCUSED, (value: Boolean) => { commit('isTabFocused', value) })
            activeSocket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION, (value: Boolean) => {
                commit('isSharingLocation', value)
                if (value === false) commit('log', i18n.t('dashboard.log.callerStoppedSharing'))
            })
            activeSocket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, (value: any) => {
                const updateMap = new Map(state.sharedNumbersList.map(status => [status[0], status[1]]))
                updateMap.set(value[0], value[1])
                commit('sharedNumbersList', Array.from(updateMap.entries()))
            })
            activeSocket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_TARGETID, (value: any) => {
                const updateMap = new Map(state.sharedTargetsList.map(status => [status[0], status[1]]))
                updateMap.set(value[0], value[1])
                commit('sharedTargetsList', Array.from(updateMap.entries()))
            })
            activeSocket.on(SOCKETIO_EVENTS.LOCATION_SHARING_ERROR, (data: any) => {
                commit('log', i18n.t('dashboard.log.callerUnableToShareLocation', { data }))
            })
            activeSocket.on('connect_timeout', () => commit('status', 'connect_timeout'))
            activeSocket.on('disconnect', () => commit('status', 'Disconnected'))
            activeSocket.on('reconnect_attempt', () => commit('status', 'Attempting to Reconnect'))
            activeSocket.on('reconnect', () => commit('status', 'reconnect'))
            activeSocket.on('error', () => commit('status', 'error'))
            activeSocket.on('reconnect_error', () => commit('status', 'Attempting to Reconnect'))
            activeSocket.on('reconnect_failed', () => commit('status', 'Unable to Reconnect'))
        },

        async connectToSocket({ dispatch, commit, state }){
            let phone = state.phoneNumber
            if (state.phoneNumber[0] == "+") phone = `${state.phoneNumber}`
            else phone = `+1${state.phoneNumber}`

            axios.post(`/api/v1/location/join-stream/${state.caseRequestUuid}/${phone}`)
            .then((response) => { 
                if (response.data.token) {
                    commit('connectionRequest', response.data)
                    let token = response.data.token
                    let activeSocket;

                    if (state.isObserver) {
                        activeSocket = createObserverSocket(token)
                        commit('observerSocket', activeSocket)
                        commit('log', i18n.t('dashboard.log.observerConnecting'))
                    } else {
                        activeSocket = socket
                        socket.connect({ token })
                    }

                    // The rest stays exactly the same — just use activeSocket instead of socket
                    activeSocket.on(SOCKETIO_EVENTS.NEW_LOCATION_AVAILABLE, (location: Location) => {
                        const isLocationInStore = state.locations.find(
                            (existingLocation) => existingLocation.dateTimeCaptured === location.dateTimeCaptured
                        )
                        if (isLocationInStore) return

                        if (location.capturedFromSource === 'TEXT_MESSAGE') commit('locationType', 'Text')

                        if (!state.callerConnected) {
                            commit('log', i18n.t('dashboard.log.callerConnected'))
                            commit('callerConnected', true)
                        }
                        commit('showWaitingForLocationModal', false)
                        commit('showSmsConfirmation', false)
                        commit('log', i18n.t('dashboard.log.newLocationReceived'))
                        commit('isSharingLocation', true)
                        commit('isTabFocused', true)
                        commit('addLocation', location)
                    })

                    activeSocket.on('connect', () => {
                        commit('log', i18n.t('dashboard.log.connectedToServer'))
                        commit('status', 'Connected')
                    })

                    activeSocket.on(SOCKETIO_EVENTS.CALLER_CONNECTED, (isConnected: Boolean) => {
                        if (isConnected) {
                            commit('log', i18n.t('dashboard.log.callerConnected'))
                            commit('callerConnected', isConnected)
                        } else {
                            commit('log', i18n.t('dashboard.log.callerDisconnected'))
                            commit('callerConnected', false)
                            commit('isTabFocused', false)
                            commit('isSharingLocation', false)
                            commit('isSharingLocationByNumber', [false, state.phoneNumber])
                        }
                    })

                    activeSocket.on(SOCKETIO_EVENTS.IS_TAB_FOCUSED, (value: Boolean) => {
                        commit('isTabFocused', value)
                    })

                    activeSocket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION, (value: Boolean) => {
                        commit('isSharingLocation', value)
                        if(value === false) {
                            commit('log', i18n.t('dashboard.log.callerStoppedSharing'))
                        }
                    })

                    activeSocket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, (value: any) => {
                        const updateMap = new Map(state.sharedNumbersList.map(status => [status[0], status[1]]));
                        updateMap.set(value[0], value[1]);
                        commit('sharedNumbersList', Array.from(updateMap.entries()));
                    })

                    activeSocket.on(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_TARGETID, (value: any) => {
                        const updateMap = new Map(state.sharedTargetsList.map(status => [status[0], status[1]]));
                        updateMap.set(value[0], value[1]);
                        commit('sharedTargetsList', Array.from(updateMap.entries()));
                    })

                    activeSocket.on(SOCKETIO_EVENTS.LOCATION_SHARING_ERROR, (data: any) => {
                        commit('log', i18n.t('dashboard.log.callerUnableToShareLocation', { data }))
                    })

                    activeSocket.on('connect_timeout', () => commit('status', 'connect_timeout'))
                    activeSocket.on('disconnect', () => commit('status', 'Disconnected'))
                    activeSocket.on('reconnect_attempt', () => commit('status', 'Attempting to Reconnect'))
                    activeSocket.on('reconnect', () => commit('status', 'reconnect'))
                    activeSocket.on('error', () => commit('status', 'error'))
                    activeSocket.on('reconnect_error', () => commit('status', 'Attempting to Reconnect'))
                    activeSocket.on('reconnect_failed', () => commit('status', 'Unable to Reconnect'))
                }
            })
        },

        async endObservationSession({dispatch, state}, socketId?: string) {
            axios.post(`api/v1/location/end-observation-session/${state.caseRequestUuid}`, { socketId })
            .then((response => {
                dispatch('observationReset')
            }))
        },

        async emitLatestLocation({dispatch, commit, state}, location: Location){
            axios.get(`api/v1/location/emit-latest-location/${state.caseRequestUuid}/${location}`)
        },

        //Print down the location and check for addLocation function if working

        async getLatestLocations({dispatch, commit, state}){
            axios.get(`api/v1/location/get-latest-location/:${state.connectionRequest.id}`)
            .then((response) => {
                commit('log', response.data.latitude)
                dispatch('emitLatestLocation', response.data)
                commit('addLocation', response.data)
            })
        },

        async latestLocation({state}){
            return state.locations[state.locations.length - 1]
            //pops off the last location of 
        },
        async chatInitiated({state}){
            if(state.chatInitiated) axios.post(`api/v1/location/chat-initiated/${state.connectionRequest.uuid}`) 
        },
        sendMobilebservationLink({state}) {
            const observationData = {
                connectionRequestUuid: state.connectionRequest.uuid,
                observationLinkNumbers: state.observationLinkNumbers,
                language: state.language,
            }
            axios.post(`api/v1/location/send-mobile-observation-sms`, observationData)
        },
        getObservationLink({ state }) {
            return axios.post(`api/v1/location/get-observation-link`, {
                connectionRequestUuid: state.connectionRequest.uuid,
                language: state.language,
            })
        },
        sendMobileObservationEmail({state}) {
            const observationData = {
                connectionRequestUuid: state.connectionRequest.uuid,
                observationLinkEmails: state.observationLinkEmails,
                language: state.language,
            }
            axios.post(`api/v1/location/send-mobile-observation-email`, observationData)
        },
        uploadEvidenceFile(_ctx, payload: { token?: string; teamId?: any; portalId?: string; locationCoords: unknown; formData: unknown; mediaFiles: File[] }) {
            const form = new FormData()
            if (payload.token) form.append('token', payload.token)
            form.append('metadata', JSON.stringify({
                locationCoords: payload.locationCoords,
                formData: payload.formData,
                portalId: payload.portalId,
            }))
            payload.mediaFiles.forEach((file) => form.append('media', file, file.name))
            axios.post('api/v1/aws/upload-evidence-file', form)
        },
        async downloadEvidenceFile(_ctx, payload: { teamId: number | string; uuid: string; firstName?: string; lastName?: string }) {
            const { teamId, uuid, firstName, lastName } = payload
            const { data } = await axios.post(
                `/api/v1/aws/download-evidence-file/${teamId}/${encodeURIComponent(uuid)}`,
                { firstName, lastName },
                { responseType: 'blob' },
            )
            const content = new Blob([data], { type: 'application/zip' })
            const nameForFile = [firstName, lastName].filter(Boolean).join(' ').trim() || 'Evidence'
            saveAs(content, `Evidence_${nameForFile}.zip`)
        },
        async saveLastWeather({state}){
            await axios.post(`api/v1/location/save-latest-weather`, {
                connectionRequestUuid: state.connectionRequest.uuid,
                weatherCondition: state.weatherCondition
            })
        },
        async triggerAIChatSummary({state}){
            try {
                const chats = (state.chatMessages || []).map((message: any) => ({
                    Author: message.author,
                    Text: message.text,
                    Dispatcher: store.state.authentication.currentUser.firstName + ' ' + store.state.authentication.currentUser.lastName,
                    ...(message.author === 'Dispatcher' ? { SentAt: message.SentAt } : { ReceivedAt: message.ReceivedAt })
                }))
                await axios.post('api/v1/location/upload-to-ai-chat-summary', {
                    connectionRequestUuid: state.connectionRequest.uuid,
                    chatlog: chats,
                })
            } catch (error) {
                console.error('AI chat summary error:', error)
            }
        },
        async submitAlertPortalInformation({ dispatch }, payload: {
            token: string
            name?: string
            phoneNumber?: string
            emergencyDescription?: string
            portalId?: string
        }) {
            const { token, name, phoneNumber, emergencyDescription, portalId } = payload
            if (!token) return

            let normalizedPhone = ''
            if (phoneNumber?.trim()) {
                normalizedPhone = decodeURIComponent(phoneNumber)
                normalizedPhone = normalizedPhone.replace(/^1(?=\d{10}$)/, '')
                if (!normalizedPhone.startsWith('+')) {
                    normalizedPhone = '+1' + normalizedPhone
                }
            }

            await dispatch('startConnection', token)

            socket.emit(SOCKETIO_EVENTS.ALERT_PORTAL_INFORMATION_SUBMITTED, {
                name: name?.trim() || undefined,
                phoneNumber: normalizedPhone || undefined,
                emergencyDescription: emergencyDescription?.trim() || undefined,
                portalId: portalId || undefined,
            })

            if (normalizedPhone) {
                socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, [normalizedPhone, true])
            }
        },
        async shareEvidenceLocation({ dispatch, commit, state }, payload: { token: string; phoneNumber: string, portalId: string }) {
            let { token, phoneNumber, portalId } = payload
            if (!token) return

            let normalizedPhone = ''
            if (phoneNumber?.trim()) {
                normalizedPhone = decodeURIComponent(phoneNumber)
                normalizedPhone = normalizedPhone.replace(/^1(?=\d{10}$)/, '')
                if (!normalizedPhone.startsWith('+')) {
                    normalizedPhone = '+1' + normalizedPhone
                }
                if (!state.callListNumbers.includes(normalizedPhone)) {
                    commit('callList', [...state.callListNumbers, normalizedPhone])
                }
            }

            await dispatch('startConnection', token)

            const targetId = normalizedPhone || portalId
            if (normalizedPhone) {
                socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, [normalizedPhone, true])
            }
            if (portalId) {
                socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_TARGETID, [portalId, true])
            }

            const watchID = navigator.geolocation.watchPosition(
                (position) => {
                    const locationPayload = {
                        timestamp: position.timestamp,
                        accuracy: position.coords.accuracy,
                        altitude: position.coords.altitude,
                        altitudeAccuracy: position.coords.altitudeAccuracy,
                        heading: position.coords.heading,
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        speed: position.coords.speed,
                        targetId,
                        phoneNumber: normalizedPhone || undefined,
                    }
                    socket.emit(SOCKETIO_EVENTS.TEXT_MESSAGE_LOCATION_UPDATE, locationPayload)
                    if (normalizedPhone) {
                        socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, [normalizedPhone, true])
                    }
                    if (portalId) {
                        socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_TARGETID, [portalId, true])
                    }
                },
                (error) => {
                    if (normalizedPhone) {
                        socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, [normalizedPhone, false])
                    }
                    if (portalId) {
                        socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_TARGETID, [portalId, false])
                    }
                    socket.emit(SOCKETIO_EVENTS.LOCATION_SHARING_ERROR, error.message)
                },
                { enableHighAccuracy: true }
            )
            // Store the watch ID for later stop capability
            commit('overwatchGeoWatchId', watchID)
        },
        async stopEvidenceLocation({ commit, state }, payload?: { phoneNumber?: string, portalId:string }) {
            const portalId = payload?.portalId
            let phoneNumber = payload?.phoneNumber || state.phoneNumber
            if (phoneNumber?.trim()) {
                phoneNumber = decodeURIComponent(phoneNumber)
                phoneNumber = phoneNumber.replace(/^1(?=\d{10}$)/, '')
                if (!phoneNumber.startsWith('+')) {
                    phoneNumber = '+1' + phoneNumber
                }
                socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_NUMBER, [phoneNumber, false])
            }
            if (portalId) {
                socket.emit(SOCKETIO_EVENTS.IS_SHARING_LOCATION_BY_TARGETID, [portalId, false])
            }
            if (state.overwatchGeoWatchId) {
                navigator.geolocation.clearWatch(state.overwatchGeoWatchId)
                commit('overwatchGeoWatchId', null)
            }
            commit('isSharingLocation', false)
        },
        async createWeaLink({ state, commit, dispatch }, teamId) {
            commit('setOverwatchMessageType', 'alert')
            const weaIdentifier = Math.random().toString(36).slice(2, 17)
            commit('weaIdentifier', weaIdentifier)

            const response = await startOverwatchWeaSession(weaIdentifier)
            if (response.data.token) {
                commit('connectionRequest', response.data)
                await dispatch('startConnection', response.data.token)
            }

            const weaLinkResponse = await axios.post('api/v1/location/request-overwatch-wea-link', {
                connectionRequestUuid: state.connectionRequest.uuid,
                teamId: teamId,
                language: state.language
            })
            commit('weaLink', weaLinkResponse.data)
        }
    }
}

export default LocationModule

export interface LocationTypes {
    mutations: {
        'location/connectionRequest': any
        'location/showSmsConfirmation': boolean
        'location/phoneNumber': string
        'location/showEmailVerificationModal': boolean
        'location/showClearedDomainModal': boolean
        'location/showEditEmailModal': boolean
        'location/showCallTransferModal': boolean
        'location/showAcceptCallTransferModal' : boolean
        'location/showAcceptCallObservationrModal': boolean
        'location/showCaseTransferModal': boolean
        'location/showFindByNumbersModal': boolean
        'location/showFindByListModal': boolean
        'location/showCreateCallListModal': boolean
        'location/showAddUsersToCLModal': boolean
        'location/showServiceAlertModal': boolean
        'location/showAddNumbersModal': boolean
        'location/showShareCaseBySmsModal': boolean
        'location/showUserProfileModal': boolean
        'location/changeCaseRequestUuid' : string
        'location/caseRequestSocketToken': string
        'location/addPhoneNumber': string
        'location/callList': any
        'location/callListNumbers': any
        'location/newNumbers' : any
        'location/setLanguage': string
        'location/setDeepLLanguage': string
        'location/setDeliveryMethod': string
        'location/setCustomSmsText': string
        'location/showA2PMessagingModal': boolean
        'location/showA2PMobileMessagingModal': boolean
        'location/showA2POverwatchModal': boolean
        'location/chatInitiated': boolean
        'location/showAPIUserMetricModal': boolean
        'location/isResponse': boolean
        'location/overwatchMessageType': string
        'location/isObserver': boolean
        'location/saveWeatherCondition': any
        'location/observationLinkNumbers': any
        'location/observationLinkEmails': any
        'location/setChatMessages': any[]
    }
    actions: {
        'location/requestLocation': {}
        'location/requestLocationSms': {}
        'location/reset': {}
        'location/observationReset': {}
        'location/downloadLocations': {}
        'location/acceptCaseTransfer': {}
        'location/denyCaseTransfer': {}
        'location/requestTransfer' : {}
        'location/checkTransfer' : {}
        'location/acceptCaseObservatoin': {}
        'location/denyCaseObservatoin': {}
        'location/requestObservatoin' : {}
        'location/checkObservatoin' : {}
        'location/checkCaseTransferConfirmation': {}
        'location/checkCaseObservationConfirmation': {}
        'location/connectObserverWithToken': {}
        'location/connectToSocket': {}
        'location/requestMultipleLocations': string
        'location/requestNewNumberLocations': string
        'location/helpRequestRequestMessage': {}
        'location/latestLocation': {}
        'location/uploadToS3': {}
        'location/uploadOverwatchToS3': {}
        'location/showA2PMessagingModal': {}
        'location/chatInitiated': {}
        'location/endObservationSession': {}
        'location/sendMobilebservationLink': {}
        'location/sendMobileObservationEmail': {}
        'location/uploadEvidenceFile': {}
        'location/downloadEvidenceFile': {}
        'location/getObservationLink': {}
        'location/downloadChatConvo': {}
        'location/saveLastWeather': {}
        'location/triggerAIChatSummary': {}
        'location/subscribeToTeamLive': {}
        'location/connectTeamCaseSocket': {}
        'location/disconnectTeamLive': {}
    }
}
